import moment from "moment"
import MasterComponent from "../../../../../components/Forms"
import { MasterConfigs } from "../../../../../interfaces/entity"
import { Button, Drawer, Tag, message, Space, notification } from "antd"
import { CopyOutlined } from "@ant-design/icons"
import Report from "./Report/Report"
import React, { useEffect } from "react"
import { allLevels } from "./AllTest"
import { encryptData, decryptData } from "../../../../../actions/crypto"
import { useDispatch } from "react-redux"
import { getData } from "../../../../../actions/apiCall"

const FailedTest = () => {
    const [isOpen, setIsOpen] = React.useState(false)
    const [selectedId, setSelectedId] = React.useState(null)
    const dispatch = useDispatch()

    const getTestLink = (testLinkId: string) => {
        if (!testLinkId) return null;
        const baseUrl = window.location.origin;
        const encryptedId = encryptData(testLinkId);
        return `${baseUrl}/instructions/${encryptedId}`;
    }

    const handleCopyTestLink = (testLinkId: string) => {
        const testLink = getTestLink(testLinkId);
        if (!testLink) {
            message.error('Test link not available');
            return;
        }
        navigator.clipboard.writeText(testLink).then(() => {
            message.success('Test link copied to clipboard!');
        }).catch(() => {
            message.error('Failed to copy test link');
        });
    }



    const config: MasterConfigs = {
        api: () => '/test-details?testStatus=failed',
        modalTitle: () => 'Test Details',
        getColumns: () => {
            return [
                {
                    title: 'Candidate Name',
                    dataIndex: 'candidate',
                    render: (text, record) => {
                        return <span>{record?.candidate?.firstName} {record?.candidate?.lastName}</span>
                    },
                },
                {
                    title: 'Current Round',
                    dataIndex: 'candidate',
                    align: 'center',
                    render: (text, record) => {
                        return <span>{allLevels.find(e => e.value == record?.candidate?.level)?.name}</span>
                    },
                },
                {
                    title: 'Level',
                    dataIndex: 'candidate',
                    align: 'center',
                    render: (text, record) => {
                        return record?.candidate?.candidateType
                    },
                },
                {
                    title: 'Test Name',
                    dataIndex: 'testConfig',
                    render: (text, record) => {
                        return record?.testConfig?.name
                    },
                },
                {
                    title: 'Link Sent At',
                    dataIndex: 'linkSentAt',
                    align: 'center',
                    render: (text, record) => {
                        return moment(record?.linkSentAt).format('lll')
                    },
                },
                {
                    title: 'Link Expired At',
                    dataIndex: 'linkExpiredAfter',
                    align: 'center',
                    render: (text, record) => {
                        return moment(record?.linkSentAt).add(record?.linkExpiredAfter, record?.expiredType).format('lll')
                    },
                },
                {
                    title: 'Status',
                    dataIndex: 'testStatus',
                    align: 'center',
                    render: (text, record) => {
                        const status = record?.testStatus
                        const statusMap = {
                            'setup-in-progress': 'Setup In Progress',
                            'pending': 'Pending',
                            'completed': 'Completed',
                            'expired': 'Expired',
                            'inporgress': 'In Progress',
                            'failed': 'Failed'
                        }

                        // use Tag from antd to show status with color
                        const statusColorMap = {
                            'setup-in-progress': 'orange',
                            'pending': 'blue',
                            'completed': 'green',
                            'expired': 'red',
                            'inporgress': 'yellow',
                            'failed': 'red'
                        }
                        const color = statusColorMap[status] || 'default'
                        return <Tag bordered={false} color={color} key={status}>
                            {statusMap[status] || 'Unknown'}
                        </Tag>
                    },
                },
                {
                    title: 'Review Status',
                    dataIndex: 'testResult',
                    align: 'center',
                    render: (text, record) => {
                        const status = record?.testResult
                        const statusMap = {
                            'Hold': 'Hold',
                            'Rejected': 'Rejected',
                            'Shortlisted': 'Shortlisted',
                            'In-Review': 'In-Review'
                        }
                        const statusColorMap = {
                            'Hold': 'orange',
                            'Rejected': 'red',
                            'Shortlisted': 'green',
                            'In-Review': 'blue'
                        }
                        const color = statusColorMap[status] || 'default'
                        return <Tag bordered={false} color={color} key={status}>
                            {statusMap[status] || 'Unknown'}
                        </Tag>
                    }
                },
                {
                    title: 'Test Link',
                    dataIndex: '_id',
                    align: 'center',
                    width: 120,
                    render: (text, record) => {
                        if (!record?.linkSentAt) {
                            return <span style={{ color: '#999' }}>Not sent</span>;
                        }
                        return (
                            <Button
                                type="link"
                                icon={<CopyOutlined />}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleCopyTestLink(record._id);
                                }}
                            >
                                Copy Link
                            </Button>
                        );
                    }
                },
                {
                    title: 'Action',
                    dataIndex: 'testStatus',
                    align: 'center',
                    width: 200,
                    render: (text, record) => {
                        return (
                            <Button type="link" onClick={() => setSelectedId(record?._id)}>
                                View Report
                            </Button>
                        )
                    }
                }
            ]
        }
    }

    useEffect(() => {
        if (selectedId) {
            setIsOpen(true)
        }
    }, [selectedId])


    return (
        <>
            <MasterComponent config={config} />
            <Drawer
                open={isOpen}
                title={
                    <div>
                        <div style={{ fontSize: '20px', fontWeight: 'bold' }}>Report</div>
                        <div style={{ fontSize: '14px', color: '#8c8c8c', marginTop: '4px' }}>Overview</div>
                    </div>
                }
                onClose={() => {
                    setIsOpen(false);
                    setSelectedId(null);
                }}
                width={'90%'}
                styles={{
                    body: { padding: '24px', background: '#f5f5f5' }
                }}
            >
                <Report id={selectedId} />
            </Drawer>
        </>
    )
}

export default FailedTest